import { render } from "./ClientsListAddModal.vue?vue&type=template&id=2b81fbc8"
import script from "./ClientsListAddModal.vue?vue&type=script&lang=js"
export * from "./ClientsListAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__